'use client';

import RenderAd from '@pickleballinc/ui/components/advertisements/render-ad';

import { ZONE_IDS } from '@/lib/ads.types';
import { env } from '@/lib/env.mjs';
import { useLocation } from '@/lib/location/location';

export const AdvertisementGallery = () => {
	const { location } = useLocation();

	return (
		<div className="w-[320px] pt-4 md:pt-6">
			<RenderAd
				zoneId={ZONE_IDS.LONG_CARD}
				pageId={100005}
				place={0}
				ipAddress={location?.query}
				containerClassname="w-full"
				showFromWidth={1024}
				isProd={env.NEXT_PUBLIC_APP_ENV === 'prod'}
				width={320}
			/>
		</div>
	);
};
